import * as React from 'react'
import styled from 'styled-components'
import { GRAY_DARK, GRAY_MEDIUM, GRAY, BLUE_LIGHT, BLACK, BLUE } from '../../../theme/colors'
import Menu from 'antd/lib/menu'
import Icon from 'antd/lib/icon'
import Dropdown from 'antd/lib/dropdown'
import Button from 'antd/lib/button'
import Input from 'antd/lib/input'
import { WHITE } from '../../../screens/DesignerTool/constants'

interface SVGFolderComponentProps {
  color?: string
  width?: string
  height?: string
}

interface StyledProps {
  color?: string
  fill?: string
  width?: string
  height?: string
  display?: boolean
  cursor?: string
  marginLeft?: string
  fontSize?: string
  isMobile?: boolean
  border?: string
  disabled?: boolean
  size?: string
  marginRight?: string
  position?: string
  top?: string
  left?: string
  right?: string
  zIndex?: string
  boxShadow?: string
  index?: number
  pointer?: string
  selected?: boolean
  secondary?: boolean
  grayed?: boolean
}

export const Container = styled.div`
  margin: 20px 0 0;
  margin-right: 36px;

  @media (max-width: 698px) {
    margin-right: 10px;
    margin-left: 6px;
  }
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: baseline;
  margin-bottom: 6px;
`

export const Title = styled.div`
  color: ${GRAY_DARK};
  display: block;
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  margin-right: 8px;
`

export const TitleDescription = styled.div`
  color: ${GRAY_MEDIUM};
  display: block;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
`

const StyledFolderSVG = styled.svg.attrs({
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink',
  viewBox: '0 0 600 479.999983',
  preserveAspectRatio: 'xMidYMid meet',
  version: '1.0',
  zoomAndPan: 'magnify',
})`
  width: ${({ width }: StyledProps) => (width ? width : '100px')};
  height: ${({ height }: StyledProps) => (height ? height : '120px')};
  transition: all .25s;
  &:hover {
    opacity: 0.8;
  }
  @media (max-width: 698px) {
    width: 42px;
    height: 40px;
  }
`

const StyledSharedFolderSVG = styled.svg.attrs({
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink',
  viewBox: '0 0 24 24',
  preserveAspectRatio: 'xMidYMid meet',
  version: '1.0',
  zoomAndPan: 'magnify',
})`
  width: ${({ width }: StyledProps) => (width ? width : '100px')};
  height: ${({ height }: StyledProps) => (height ? height : '120px')};
  fill: ${({ color }: StyledProps) => (color ? color : BLACK)};
  position: absolute;
  left: 40px;
  top: 8px;
  transition: all .25s;
  @media (max-width: 698px) {
    left: 16px;
    top: 0px;
  }
`

const StyledCreateFolderSVG = styled.svg.attrs({
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink',
  viewBox: '0 0 637.5 479.999983',
  preserveAspectRatio: 'xMidYMid meet',
  version: '1.0',
  zoomAndPan: 'magnify',
})`
  width: ${({ width }: StyledProps) => (width ? width : '100px')};
  height: ${({ height }: StyledProps) => (height ? height : '120px')};
  transition: all .25s;
`

const Path = styled.path`
  fill: ${({ fill }: StyledProps) => (fill ? fill : BLUE_LIGHT)};
  fill-opacity: 1;
  fill-rule: nonzero;
`

export const SVGFolderComponent = ({ color, width, height }: SVGFolderComponentProps) => (
  <StyledFolderSVG {...{ width, height }}>
    <Path 
      fill={color}
      d="M 240 0 L 60 0 C 26.851562 0 0.300781 
      26.851562 0.300781 60 L 0 420 C 0 453.148438 
      26.851562 480 60 480 L 540 480 C 573.148438 
      480 600 453.148438 600 420 L 600 120 C 600 
      86.851562 573.148438 60 540 60 L 300 60 Z 
      M 240 0" 
    />
  </StyledFolderSVG>
)

export const SVGSharedFolderComponent = ({ color, width, height }: SVGFolderComponentProps) => (
  <StyledSharedFolderSVG {...{ color, width, height }}>
    <g data-name="Layer 2">
      <g data-name="people">
        <rect {...{ width, height }} opacity="0" />
        <path d="M9 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2z" />
        <path d="M17 13a3 3 0 1 0-3-3 3 3 0 0 0 3 3zm0-4a1 1 0 1 1-1 1 1 1 0 0 1 1-1z" />
        <path d="M17 14a5 5 0 0 0-3.06 1.05A7 7 0 0 0 2 20a1 1 0 0 0 2 0 5 5 0 0 1 10 0 1 
        1 0 0 0 2 0 6.9 6.9 0 0 0-.86-3.35A3 3 0 0 1 20 19a1 1 0 0 0 2 0 5 5 0 0 0-5-5z" 
      />
      </g>
    </g>
  </StyledSharedFolderSVG>
)

export const SVGCreateFolderComponent = ({ color, width, height }: SVGFolderComponentProps) => (
  <StyledCreateFolderSVG {...{ width, height }}>
    <defs>
      <clipPath id="48dd7a0d7a">
        <path 
          d="M 23.949219 27.035156 L 589.753906 27.035156 L 589.753906 479.679688 
          L 23.949219 479.679688 Z M 23.949219 27.035156 " 
          clip-rule="nonzero" 
         />
      </clipPath>
      <clipPath id="01a53c0d1a">
        <path 
          d="M 438.898438 38.167969 L 637 38.167969 L 637 236.269531 L 
          438.898438 236.269531 Z M 438.898438 38.167969 " 
          clip-rule="nonzero" 
        />
      </clipPath>
      <clipPath id="e83a23387f">
        <path 
           d="M 537.949219 38.167969 C 483.246094 38.167969 438.898438 
           82.515625 438.898438 137.21875 C 438.898438 191.921875 483.246094 236.269531 
           537.949219 236.269531 C 592.652344 236.269531 637 191.921875 637 137.21875 C 
           637 82.515625 592.652344 38.167969 537.949219 38.167969 Z M 537.949219 38.167969 " 
           clip-rule="nonzero" 
        />
      </clipPath>
      <clipPath id="42044beda0">
        <path 
          d="M 449.820312 45.511719 L 630.253906 45.511719 L 630.253906 225.945312 L 
          449.820312 225.945312 Z M 449.820312 45.511719 " 
          clip-rule="nonzero" 
        />
      </clipPath>
      <clipPath id="6540adaad1">
        <path 
          d="M 540.035156 45.511719 C 490.210938 45.511719 449.820312 85.902344 449.820312 
          135.726562 C 449.820312 185.550781 490.210938 225.945312 540.035156 225.945312 C 
          589.863281 225.945312 630.253906 185.550781 630.253906 135.726562 C 630.253906 
          85.902344 589.863281 45.511719 540.035156 45.511719 Z M 540.035156 45.511719 " 
          clip-rule="nonzero" 
        />
      </clipPath>
      <clipPath id="8e84f69532">
        <path 
          d="M 486 81.554688 L 594 81.554688 L 594 190 L 486 190 Z M 486 81.554688 " 
          clip-rule="nonzero" 
        />
      </clipPath>
    </defs>
    <g clip-path="url(#48dd7a0d7a)">
      <path 
        fill={color} 
        d="M 250.335938 27.035156 L 80.546875 27.035156 C 49.277344 27.035156 24.234375 
        52.359375 24.234375 83.628906 L 23.949219 423.210938 C 23.949219 454.480469 49.277344 
        479.808594 80.546875 479.808594 L 533.320312 479.808594 C 564.589844 479.808594 
        589.917969 454.480469 589.917969 423.210938 L 589.917969 140.226562 C 589.917969 
        108.957031 564.589844 83.628906 533.320312 83.628906 L 306.933594 83.628906 Z M 250.335938
        27.035156 " 
        fill-opacity="1" 
        fill-rule="nonzero" 
      />
    </g>
    <g clip-path="url(#01a53c0d1a)">
      <g clip-path="url(#e83a23387f)">
        <path 
          fill="#ffffff" 
          d="M 438.898438 38.167969 L 637 38.167969 L 637 236.269531 L 438.898438 236.269531 
          Z M 438.898438 38.167969 " 
          fill-opacity="1" 
          fill-rule="nonzero" 
          />
      </g>
    </g>
    <g clip-path="url(#42044beda0)">
      <g clip-path="url(#6540adaad1)">
        <path stroke-linecap="butt" 
          transform="matrix(0.749412, 0, 0, 0.749412, 449.820101, 45.511159)" 
          fill="none" 
          stroke-linejoin="miter" 
          d="M 120.381088 0.000746291 C 53.896689 0.000746291 0.000282003 53.897154 
          0.000282003 120.381552 C 0.000282003 186.86595 53.896689 240.76757 120.381088 
          240.76757 C 186.870698 240.76757 240.767106 186.86595 240.767106 120.381552 C 
          240.767106 53.897154 186.870698 0.000746291 120.381088 0.000746291 Z M 120.381088 
          0.000746291 " 
          stroke="#38b6ff" 
          stroke-width="40" 
          stroke-opacity="1" 
          stroke-miterlimit="4" 
          />
      </g>
    </g>
    <g clip-path="url(#8e84f69532)">
      <path 
        fill="#38b6ff" 
        d="M 539.902344 81.433594 C 539.316406 81.441406 538.734375 81.507812 538.160156 
        81.632812 C 537.585938 81.753906 537.027344 81.933594 536.488281 82.164062 C 535.949219
        82.398438 535.4375 82.679688 534.953125 83.011719 C 534.46875 83.347656 534.023438 
        83.722656 533.613281 84.144531 C 533.203125 84.566406 532.839844 85.023438 532.519531 
        85.515625 C 532.199219 86.011719 531.929688 86.53125 531.714844 87.074219 C 531.496094 
        87.621094 531.335938 88.183594 531.226562 88.761719 C 531.121094 89.339844 531.070312 
        89.921875 531.078125 90.507812 L 531.078125 126.324219 L 495.265625 126.324219 C 494.671875 
        126.316406 494.085938 126.363281 493.5 126.472656 C 492.917969 126.582031 492.351562 
        126.746094 491.800781 126.96875 C 491.25 127.1875 490.726562 127.460938 490.230469 127.789062 
        C 489.734375 128.113281 489.273438 128.484375 488.851562 128.902344 C 488.429688 129.316406 
        488.054688 129.769531 487.71875 130.261719 C 487.386719 130.753906 487.109375 131.273438 
        486.878906 131.820312 C 486.648438 132.367188 486.476562 132.933594 486.359375 133.515625 C 
        486.242188 134.097656 486.183594 134.683594 486.183594 135.277344 C 486.183594 135.871094 
        486.242188 136.457031 486.359375 137.039062 C 486.476562 137.621094 486.648438 138.183594 
        486.878906 138.734375 C 487.109375 139.28125 487.386719 139.800781 487.71875 140.289062 C 
        488.054688 140.78125 488.429688 141.238281 488.851562 141.652344 C 489.273438 142.070312 
        489.734375 142.441406 490.230469 142.765625 C 490.726562 143.089844 491.25 143.363281 491.800781 
        143.585938 C 492.351562 143.804688 492.917969 143.972656 493.5 144.078125 C 494.085938 
        144.1875 494.671875 144.238281 495.265625 144.230469 L 531.078125 144.230469 L 531.078125 
        180.042969 C 531.070312 180.636719 531.121094 181.226562 531.230469 181.808594 C 531.339844 
        182.390625 531.503906 182.957031 531.726562 183.507812 C 531.945312 184.058594 532.21875 
        184.582031 532.542969 185.078125 C 532.871094 185.574219 533.242188 186.035156 533.65625 
        186.457031 C 534.074219 186.878906 534.527344 187.257812 535.019531 187.589844 C 535.511719 
        187.921875 536.03125 188.203125 536.578125 188.429688 C 537.125 188.660156 537.6875 188.832031
        538.269531 188.949219 C 538.851562 189.066406 539.441406 189.125 540.035156 189.125 C 540.625 
        189.125 541.214844 189.066406 541.796875 188.949219 C 542.378906 188.832031 542.941406 188.660156 
        543.488281 188.429688 C 544.035156 188.203125 544.554688 187.921875 545.046875 187.589844 C 
        545.539062 187.257812 545.992188 186.878906 546.410156 186.457031 C 546.824219 186.035156 
        547.195312 185.574219 547.523438 185.078125 C 547.847656 184.582031 548.121094 184.058594 
        548.34375 183.507812 C 548.5625 182.957031 548.726562 182.390625 548.835938 181.808594 C 
        548.945312 181.226562 548.996094 180.636719 548.988281 180.042969 L 548.988281 144.230469 L 
        584.800781 144.230469 C 585.394531 144.238281 585.980469 144.1875 586.566406 144.078125 C 
        587.148438 143.972656 587.714844 143.804688 588.265625 143.585938 C 588.816406 143.363281 
        589.339844 143.089844 589.835938 142.765625 C 590.332031 142.441406 590.792969 142.070312 
        591.214844 141.652344 C 591.636719 141.238281 592.015625 140.78125 592.347656 140.289062 C 
        592.679688 139.800781 592.957031 139.28125 593.1875 138.734375 C 593.417969 138.183594 593.589844 
        137.621094 593.707031 137.039062 C 593.824219 136.457031 593.882812 135.871094 593.882812 135.277344 
        C 593.882812 134.683594 593.824219 134.097656 593.707031 133.515625 C 593.589844 132.933594 593.417969
        132.367188 593.1875 131.820312 C 592.957031 131.273438 592.679688 130.753906 592.347656 130.261719 C 
        592.015625 129.769531 591.636719 129.316406 591.214844 128.902344 C 590.792969 128.484375 590.332031 
        128.113281 589.835938 127.789062 C 589.339844 127.460938 588.816406 127.1875 588.265625 126.96875 C 
        587.714844 126.746094 587.148438 126.582031 586.566406 126.472656 C 585.980469 126.363281 585.394531 
        126.316406 584.800781 126.324219 L 548.988281 126.324219 L 548.988281 90.507812 C 548.996094 89.910156
        548.945312 89.316406 548.832031 88.730469 C 548.722656 88.140625 548.554688 87.570312 548.328125 87.015625 
        C 548.101562 86.460938 547.824219 85.933594 547.492188 85.433594 C 547.164062 84.9375 546.785156 84.476562 
        546.363281 84.050781 C 545.9375 83.628906 545.476562 83.253906 544.976562 82.921875 C 544.480469 82.589844 
        543.953125 82.3125 543.398438 82.089844 C 542.84375 81.863281 542.269531 81.695312 541.683594 81.585938 C 
        541.09375 81.476562 540.5 81.425781 539.902344 81.433594 Z M 539.902344 81.433594 " 
        fill-opacity="1" 
        fill-rule="nonzero" />
    </g>
  </StyledCreateFolderSVG>
)

export const TitlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${({ secondary }: StyledProps) => secondary ? '-3px' : ''};
  opacity: ${({ grayed }: StyledProps) => grayed ? '0.7' : '1'};
  @media (max-width: 698px) {
    margin-left: 10px;
    margin-top: 0;
    align-items: flex-start;
  }
`

export const FolderName = styled.div`
  font-size: 12px;
  color: ${({ color }: StyledProps) => (color ? color : GRAY_DARK)}; 
  margin-bottom: 4px;
  margin-top: 2px;
`

export const FolderItemsLabel = styled.div`
  font-size: 10px;
  color: #00AFF2;
  font-weight: 600;
`

export const FolderList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  @media (max-width: 698px) {
    flex-flow: row;
    flex-wrap: wrap;
  }
`

export const RightSeparator = styled.div`
  @media (max-width: 698px) {
    margin-right: 42px;
  }
`

export const ColumnLeft = styled.div``

export const ColumnRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 698px) {
    flex-direction: row;
    align-items: center;
  }
`

export const InsideIcon = styled.div`
  position: relative;
`

export const FolderDivIcon = styled.div`
  left: 0;
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`

export const FolderItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 16px;
  position: relative;
  padding: 0 8px;
  transition: all .25s;
  animation: fade-in-column-folder 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) 
    ${({ index }: StyledProps) => index ? index * 0.15 : 0 }s both;
  @keyframes fade-in-column-folder {
    0% {
      transform: translateX(-10px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  @media (max-width: 698px) {
    flex-direction: row;
    justify-content: space-between;
    margin-right: 0;
    padding: 0;
  }

  &:hover {
    background: #cff1ffa7;
    border: ${({ border }: StyledProps) => (border ? `2px ${border} #8adeff` : 'none')};
    cursor: pointer;
    border-radius: 10px;
  }
`

export const StyledMenu = styled(Menu)`
  box-shadow: 0 2px 8px #00000063;
  font-family: Avenir;
  width: 250px;

  .ant-dropdown-menu-item .anticon:first-child {
    margin-right: 10px;
  }

  .ant-dropdown-menu-item {
    line-height: 25px;
    font-size: 14.5px;
    border-top: 1px solid #f3f3f3;   
    &:first-child {
      border-top: none;
    }
  }
`

export const MenuHeaderContainer = styled(Menu.Item)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  cursor: default; 
  font-size: ${({ fontSize }: StyledProps) => fontSize === 'small' ? '12px' : 'unset' };
  &:hover {
    background: none;
  }
`

export const MenuHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin: 4px 0;
`

export const MenuHeaderTitle = styled.p`
  font-weight: 600;
  font-size: 17px;
  margin: 0;
`

export const MenuHeaderText = styled.p`
  font-size: 12px;
  margin-bottom: 6px;
  white-space: break-spaces;
`

export const StyledIcon = styled(Icon)`
  cursor: ${({ cursor }: StyledProps) => (cursor ? cursor : 'unset')};
  margin-left: ${({ marginLeft }: StyledProps) => (marginLeft ? marginLeft : '0')};
  margin-right: ${({ marginRight }: StyledProps) => (marginRight ? marginRight : '0')};
  color: ${({ color }: StyledProps) => (color ? color : 'unset')};
  position: ${({ position }: StyledProps) => (position ? position : 'unset')};
  top: ${({ top }: StyledProps) => (top ? top : 'unset')};
  right: ${({ right }: StyledProps) => (right ? right : 'unset')};
  z-index: ${({ zIndex }: StyledProps) => (zIndex ? zIndex : 'unset')};
  box-shadow: ${({ boxShadow }: StyledProps) => (boxShadow ? boxShadow : 'unset')};
  pointer: ${({ pointer }: StyledProps) => (pointer ? pointer : 'unset')};
`

export const FolderIcon = styled(Icon)` 
  color: ${WHITE};
  position: absolute;
  font-size: 18px;
`

export const StyledModalIcon = styled(Icon)`
  margin-right: 10px;
  `

export const InputIconListContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

export const StyledInputIcon = styled(Icon)`
  font-size: 24px;
  padding: 8px;
  color: ${GRAY_MEDIUM};
  transition: hover .100s ease-in-out;
  border-radius: 25px;
  transition: all .25s;
  ${({ selected }: StyledProps) => selected && `
    color: ${BLUE_LIGHT};
    background: #e9f1ff;
  `}

  &:hover {
    color: ${BLUE_LIGHT};
    cursor: pointer;
  }
`

export const ColorPickerIcon = styled(Icon)`
  color: ${WHITE};
  position: absolute;
  top: 10px;
  right: 6px;
  z-index: 3;
  pointer-events: none;
  cursor: pointer;
`

export const MenuItemCustom = styled(Menu.Item)`
  display: flex;
  align-items: center;
  cursor: default;

  &:hover {
    background: none;
  }
`

export const ColorsContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0;
  position: relative;
`

export const ColorPickerContainer = styled.div`
  display: flex;
  margin-left: 10px;
`

export const CustomColorPickerContainer = styled.div`
  position: relative;
` 

export const Color = styled.div`
  width: ${({ size }: StyledProps) => (size ? size : '14px')};
  height: ${({ size }: StyledProps) => (size ? size : '14px')};
  border-radius: 50%;
  background: ${({ color }: StyledProps) => (color ? color : 'unset')};
  margin-left: 4px;
  margin-top: 2px;
  margin-bottom: 2px;
  cursor: pointer;
  transition: all 0.25s ease-in-out;

  ${({ selected }: StyledProps) => selected && `
    box-shadow: 0 0 0 2px #838383;
  `}

  &:hover {
    border: 2px solid #c1c1c1;
  }
`

export const ColorPicker = styled.input`
  border-radius: 50%;
  width: ${({ size }: StyledProps) => (size ? size : '14px')};
  height: ${({ size }: StyledProps) => (size ? size : '14px')};
  cursor: pointer;
  margin-left: 4px;
  margin-top: 2px;
  margin-bottom: 2px;
  border: 1px solid #fff;
  appearance: none;
  transition: background 0.5s;
  transition: opacity 0.25s ease-in-out;
  &::-webkit-color-swatch {
    display: none;
  }
  &::before {
    content: "";
    position: absolute;
    top: 3px;
    right: -1px;
    border-radius: 50%;
    border: 1px solid white;
    width: ${({ size }: StyledProps) => (size ? size : '14px')};
    height: ${({ size }: StyledProps) => (size ? size : '14px')};
    background: ${({ color }: StyledProps) => 
      (color ? color : 'conic-gradient(red, orange, yellow, green, blue, indigo, violet, red)')};
    transition: transform 0.5s;
    ${({ selected }: StyledProps) => selected && `box-shadow: 0 0 0 2px #838383;`}
  }
  &:hover::before {
    transform: rotate(180deg);
  }
`

export const PlusIcon = styled(Icon)`
  color: ${GRAY};
`

export const MenuActions = styled.div`
  position: absolute;
  right: -8px;
  top: 2px;
  background: ${WHITE};
  border-radius: 25px;
  padding: 2px;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  transition: all .25s;
  display: flex;
  border: 1px solid ${BLUE};
  &:hover {
    background: #c9d0d3;
    cursor: pointer;
  }
  @media (max-width: 698px) {
    background: #e1e6e8;
  }
`

export const MenuActionsMobile = styled.div`
  border-radius: 3px;
  background: white;
  border: 1px solid #e3e3e3;
  margin-left: 12px;
  margin-right: 30px;
  padding: 4px;
  padding-left: 4px;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  transition: all .25s;
  &:hover {
    background: #c9d0d3;
  }
`

export const DotsIcon = styled(Icon)`
  filter: contrast(5);
  color: #008bc0;
  font-size: 14px;
  font-weight: 600;
  @media (max-width: 698px) {
    font-size: 18px;
  }

  &:hover {
    color: ${WHITE};
  }
`

export const DropdownStyled = styled(Dropdown)``

export const DropdownStyledMobile = styled(Dropdown)``

export const ModalTitle = styled.p`
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  margin-bottom: 30px;
`

export const CustomIconContainer = styled.div`
  margin-right: 10px;
`

export const CustomIcon = styled.img`
  width: 28px;
`

export const CreateFolderForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const CreateFolderInput = styled(Input)`
  border-radius: 0;
`

export const InputLabelContainer = styled.div`
  display: flex;
  margin-bottom: 5px;
`

export const Label = styled.div`
  height: 19px;
  color: #5f6062;
  font-size: 14px;
  letter-spacing: 0.18px;
  line-height: 19px;
`

export const ErrorMessage = styled.p`
  color: red;
  font-size: 12px;
  margin: 0;
  margin-top: 10px;
`

export const StyledInput = styled(Input)`
  height: 40px;
  width: 100%;
  border: 1px solid #bebebe;
  border-radius: 5px;
`

export const ContinueButton = styled(Button)`
  width: 100%;
  height: 34px;
  box-shadow: 0px 1px 3px 0px silver;
  color: ${WHITE};
  background-color: #4A90E2; 
  border-color: #4A90E2;

  &:hover {
    color: ${WHITE};
    background-color: #81b3ed;
    border-color: #81b3ed;
  }
`

export const InputRow = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-bottom: 20px;
`

export const FolderAnimation = styled.img`
  max-width: 300px;
  width: 100%;
  object-fit: contain;

  @media (max-width: 698px) {
    max-width: 200px;
  }
`

export const ModalColumnLeft = styled.div`
  width: 50%;
  border-right: 1px solid #e3e8ea;
  padding-right: 20px;

  @media (max-width: 698px) {
    width: 100%;
    border-right: none;
    padding-right: 0;
  }
`

export const ModalColumnRight = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #e9f5ff;
  @media (max-width: 698px) {
    width: 100%;
    margin-top: 20px;
  }
`

export const Columns = styled.div`
  display: flex;

  @media (max-width: 698px) {
    flex-direction: column;
  }
`

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  padding: 20px 37px;
  border-radius: 7px;
  background: linear-gradient(45deg,#7dc8ff,#cfc1ff);
  box-shadow: 1px 2px 3px -1px silver;
  @media (max-width: 698px) {
    padding: 20px 60px;
  }
`

export const CreateFolderMessageItem = styled.p`
  font-size: 18px;
  color: ${WHITE};
  margin: 0;
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0px;
  }
  @media (max-width: 698px) {
    font-size: 14px;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MyLocker/FoldersView/styledComponents.tsx